var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout-svgrepo-com_1_",
    "data-name": "logout-svgrepo-com (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.022,
    height: 23.927,
    viewBox: "0 0 25.022 23.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37865",
    "data-name": "Group 37865",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37864",
    "data-name": "Group 37864",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65370",
    "data-name": "Path 65370",
    d: "M80.95,6.5a11.876,11.876,0,0,1,7.018,2.274.555.555,0,0,1,.147.74L86.188,12.64a.555.555,0,0,1-.8.158,7,7,0,1,0,0,11.332.555.555,0,0,1,.8.158l1.926,3.125a.555.555,0,0,1-.147.74A11.963,11.963,0,1,1,80.95,6.5Z",
    transform: "translate(-68.987 -6.5)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65371",
    "data-name": "Path 65371",
    d: "M8.516,101.032a.555.555,0,0,1,.027-.57l1.3-1.954H1.963a1.963,1.963,0,0,1,0-3.926H9.846l-1.3-1.954A.555.555,0,0,1,9,91.765H12.76a.555.555,0,0,1,.462.247l2.817,4.225a.555.555,0,0,1,0,.616l-2.817,4.225a.555.555,0,0,1-.462.247H9A.555.555,0,0,1,8.516,101.032Z",
    transform: "translate(8.89 -84.581)",
    fill: "#2580ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9c91ec964148e08b01d38e8dda920be9.svg";
export { ForwardRef as ReactComponent };